import getCsrf from '../../cookies/getCsrf';
import encryptDecrypt from '../../cryptography/encryptDecrypt';
import config from '../../../config/config';
import moment from 'moment';
import resolveExpression from '../simpleScript/expressionParser/resolveExpression';

export default async function (
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={},
){
    try{
        const {
            executionObject={}
        } = functionObj;
        const {
            secretKeyId='',
            variableName='', variableUnavailable=false,
            dynamicSecretKey=false, dynamicSecretKeyId={}
        } = executionObject;
        const {
            companyId='', inhouz_reserved_parameters_xyzh={}
        } = parameterObject;
        const {appEnvironment=''} = inhouz_reserved_parameters_xyzh;

        if(!variableName || variableUnavailable){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Variable name is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(
            !companyId ||
            typeof companyId !== 'string'
        ){
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Owner ID is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let variableCopy = variableObject;
        let skId = secretKeyId;
        if(dynamicSecretKey){
            let resolvedSkId = await resolveExpression(
                dynamicSecretKeyId,
                variableCopy,
                parameterObject,
                functionMap,
                variableIdMap
            );
            skId = resolvedSkId.value;
            variableCopy = resolvedSkId.variableObject;
        }

        if(
            !skId ||
            typeof skId !== 'string'
        ){
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : 'Secret Key is missing.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let encryptedCompanyId = encryptDecrypt(
            JSON.stringify({
                companyId,
                expirationTimestamp : moment().add(1000, 'seconds').unix() * 1000
            }),
            true
        );

        //get secret
        let secretObj = await fetch(
            `${config.devServerProxy}/api/secret/getsecret`,
            {
                method : 'POST',
                headers : {
                    'Accept':"application/json",
                    'Content-Type':"application/json",
                    'Cache': 'no-cache',
                    'x-csrfToken' : getCsrf()
                },
                credentials : 'include',
                body : JSON.stringify({
                    secretKeyId : skId,
                    encryptedCompanyId,
                    environment : appEnvironment
                })
            }
        )
        .then(async res => {
            if(res.status !== 200){
                return {
                    error : {
                        message : 'An error occured while getting secret securely.'
                    }
                }
            }
            let jsonResponse = await res.json();
            if(jsonResponse.error){
                return {
                    error : {
                        message : jsonResponse.error.message
                    }
                }
            }
            return jsonResponse;
        })
        .catch((error) => {
            console.log('secretKeyParser catch block error', error);
            return {
                error : {
                    message : ''
                }
            };
        });

        if(secretObj.error){
            return {
                updatedVariableObject : variableCopy,
                hasError : true,
                errorPayload : secretObj.error.message || 'An error occured while getting secret securely.',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        let {
            secretValue=''
        } = secretObj;

        variableCopy[variableName] = encryptDecrypt(secretValue, false);
        return {
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableCopy,
            hasError : secretObj.hasError || secretObj.error ? true : false,
            errorPayload : secretObj.hasError || secretObj.error ? secretObj : undefined
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/secretKeyParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        }
    }
}